<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { kenwoodItalyBasicMixin } from '../../modules/kenwood_italy_mixins_module.js';
import { sendFandomAnalyticsEvent }  from 'src/modules/fandom_analytics_module.js';
import { get, merge } from 'lodash';

export default {
  mixins: [fandomBasicMixin, kenwoodItalyBasicMixin],
  data() {
    return {
      activeIndex: 0,
      activeStep: null,
      userJourney: [],
      profilerContent: {},
      profilerNameToContent: {},
      efNameToUserSelectedItems: {},
      preserveFullScreen: false,
      enterClass: 'slideInRight',
      leaveClass: 'slideOutLeft',
      init: false,
    }
  },
  mounted() {
    $('#modal-profiler').on('shown.bs.modal', () => {
      sendFandomAnalyticsEvent('Profiler modal', 'Show', null);
      if (!this.init) {
        this.initSteps();
      }
    })
    $('#modal-profiler').on('hidden.bs.modal', () => {
      this.activeIndex = 0;
    })
  },
  methods: {
    initSteps() {
      Fandom.post({
        data: {main_content_name: this.content.profiler},
        url: "/api/v5/get_contents",
        success: (data) => {
          Vue.set(this, "profilerContent", data.name_to_content[this.content.profiler]);
          Vue.set(this, "profilerNameToContent", data.name_to_content);
          const user = get(globalState.pageModel, ['user'], {});
          this.steps.forEach(step => {
            if (user[step.extra_field_name])
              Vue.set(this.efNameToUserSelectedItems, step.extra_field_name, user[step.extra_field_name]);
            else
              Vue.set(this.efNameToUserSelectedItems, step.extra_field_name, []);
          });
          this.setActiveStep();
          this.init = true;
        }
      });
    },
    updateUserPreference(callback) {
      const efName = this.activeStep.extra_field_name;
      Fandom.ajax({
        url: '/api/v5/user/update_user_profile',
        method: 'POST',
        data: {
          key: efName,
          value: this.efNameToUserSelectedItems[efName],
          min_length: this.activeStep.min_length,
          max_length: this.activeStep.max_length
        },
        success: (data) => {
          Vue.set(this.pageModel, 'user', merge(this.pageModel.user, data));
          callback(data);
        }
      })
    },
    toggleOption(option) {
      const efName = this.activeStep.extra_field_name;
      const index = this.efNameToUserSelectedItems[efName].indexOf(option);
      if (index > -1) {
        Vue.delete(this.efNameToUserSelectedItems[efName], index);
      } else {
        Vue.set(this.efNameToUserSelectedItems[efName], this.efNameToUserSelectedItems[efName].length, option);
      }
    },
    close() {
      $('#modal-profiler').modal("hide");
    },
    skip() {
      const date = new Date();
      const expireDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, date.getHours(), date.getMinutes(), date.getSeconds()).toUTCString();
      Fandom.setCookie("kenwood-italy-hide-profiler-registered", true, expireDate);
      this.close();
    },
    setAndGoTo(button) {
      const callbackWrapper = this.activeStep.extra_field_name ? (cb) => this.updateUserPreference(cb) : (cb) => cb(); 
      if (button.button_value)
        this.efNameToUserSelectedItems[this.activeStep.extra_field_name] = button.button_value;
      if (button.button.url.startsWith("$goto:")) {
        let newIndex = button.button.url.split("$goto:")[1];
        const callback = (_) => {
          if (this.steps[newIndex]) {
            this.activeIndex = newIndex;
            Vue.set(this, 'preserveFullScreen', (!this.activeStep.small));
            Vue.set(this, 'activeStep', null);
          }
        }
        if (newIndex === "back") {
          let _ = this.userJourney.pop();
          newIndex = this.userJourney.pop();
          callback();
        } else if (newIndex === "close") {
          this.close();
        } else {
          newIndex = parseInt(newIndex);
          switch (newIndex) {
            case 1:
              sendFandomAnalyticsEvent('Profiler modal', 'Product owner', null);
              break;
            case 2:
              if (this.efNameToUserSelectedItems.owned_products.length > 0) {
                sendFandomAnalyticsEvent('Profiler modal', 'Product added', null);
              } else {
                sendFandomAnalyticsEvent('Profiler modal', 'Not product owner', null);
              }
              break;
          }
          callbackWrapper(callback);
        }
      } else {
        const callback = () => { window.location.href = button.button.url };
        callbackWrapper(callback);
      }
    },
    setActiveStep() {
      Vue.set(this, 'activeStep', this.steps[this.activeIndex]);
      Vue.set(this, 'userJourney', [...this.userJourney, this.activeIndex]);
    },
    isButtonEnabled(button) {
      if (
        this.activeStep.extra_field_name &&
        this.activeStep.options &&
        button.button.url.indexOf("$goto:") > -1 &&
        button.button.url.split("$goto:")[1] != "back"
      ) {
        return (
          this.efNameToUserSelectedItems[this.activeStep.extra_field_name].length >= (this.activeStep.min_length || -1) &&
          this.efNameToUserSelectedItems[this.activeStep.extra_field_name].length <= (this.activeStep.max_length || 100000)
        )
      }
      return true;
    },
  },
  computed: {
    steps() {
      return this.profilerContent.steps || [];
    },
    indexedSteps() {
      return this.steps.filter(s => s.index).length;
    },
    activeStepOptions() {
      if (this.activeStep && this.activeStep.options) {
        return this.activeStep.options.map(option => {
          return this.profilerNameToContent[option];
        })
      } else {
        return [];
      }
    },
    activeStepButtons() {
      const buttons = get(this, ["activeStep", "buttons"], []);
      if (Fandom.isUserRegistered()) {
        return buttons.filter(b => !b.anonymous_only);
      } else {
        return buttons.filter(b => !b.registered_only);
      }
    },
    activeOptions() {
      const efName = this.activeStep.extra_field_name;
      return this.efNameToUserSelectedItems[efName];
    },
    modalFullScreen() {
      return (this.activeStep && !this.activeStep.small) || (!this.activeStep && this.preserveFullScreen);
    },
  }
};
</script>

<template>
  <div 
    id="modal-profiler"
    data-keyboard=false
    data-backdrop="static"
    tabindex="-1"
    class="modal fade"
    modal-profiler-component
  >
    <div class="modal-dialog modal-dialog-centered" :class="{'modal-full': modalFullScreen}">
      <div class="modal-content">
        <div class="modal-body p-0">
          <div class="close-icon p-3">
            <i class="fal fa-times fa-2x cursor-pointer" @click="skip"></i> 
          </div>
          <div v-if="steps.length > 0" :class="{'mh-100vh': modalFullScreen}">
            <transition enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster" @after-leave="setActiveStep">
              <div v-if="activeStep" class="container h-100 d-flex flex-column justify-content-center text-center py-5">
                <div class="row">
                  <div class="col-12">
                    <div class="mx-auto mb-5 w-75" v-if="activeStep.image">
                      <div class="w-100 ar-16by9 bg-cover-center" :style="{'background-image': `url(${activeStep.image.url})`}"></div>
                    </div>
                    <component :is="activeStep.title_tag || 'h2'" class="title-composed" v-if="activeStep.title_composed">
                      <span v-for="(title, index) in activeStep.title_composed" :key="`title-${index}`" :class="getTitleStyle(title)">
                        {{title.title}}
                      </span>
                    </component>
                    <div class="separator" v-if="activeStep.separator">
                      <span>{{activeStep.separator}}</span>
                    </div>
                    <div class="row justify-content-center">
                      <div class="col-12 col-md-10 col-sm-10">
                        <component v-if="activeStep.title" :is="activeStep.title_tag || 'h3'">{{activeStep.title}}</component>
                        <div class="row justify-content-center py-4 options-container" v-if="activeStep.options" :key="`step-${activeIndex}`">
                          <div
                            v-for="option in activeStepOptions"
                            :key="`option-${option.name}`"
                            :class="activeStep.show_options_descriptions ? 'col-12' : 'col-6'"
                            class="col-md-4 col-lg-3 py-3"
                          >
                            <div class="w-100 ar-1by1 position-relative">
                              <div
                                @click="toggleOption(option.name)"
                                :class="activeOptions.indexOf(option.name) > -1 ? 'bg-lemon-grass-lighter' : 'bg-kenwood-light-grey'"
                                class="option p-3 position-absolute-center cursor-pointer d-flex flex-column justify-content-center align-items-center text-center rounded-circle"
                              >
                                <div class="w-80">
                                  <div :style="{'background-image': `url(${option.thumbnail.url})`}" class="bg-contain-center w-100 ar-1by1"></div>
                                </div>
                                <div v-if="activeOptions.indexOf(option.name) > -1" class="position-absolute-center d-flex justify-content-center align-items-center opacity-75">
                                  <div class="d-flex justify-content-center align-items-center rounded-circle bg-white p-3 opacity-90">
                                    <i class="fal fa-2x fa-check"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <h6 class="mt-2">{{option.title}}</h6>
                            <p v-if="activeStep.show_options_descriptions" v-html="option.description"></p>
                          </div>
                        </div>
                        <div class="d-flex justify-content-center flex-wrap" v-if="activeStep.buttons">
                          <button
                            v-for="button in activeStepButtons" :key="`button-${button.$id}`"
                            class="btn mx-3 py-3 mt-3 btn-min-width px-4 px-md-5"
                            :disabled="!isButtonEnabled(button)"
                            @click="setAndGoTo(button)"
                            :class="[button.button_class || 'btn-primary', {'w-100': activeStep.small}]"
                          >{{button.button.title}}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div v-else class="d-flex w-100 h-100 align-items-center justify-content-center py-5">
            <i class="fad fa-spinner fa-spin fa-3x text-primary fa-pulse"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[modal-profiler-component] {
  .modal {
    &-dialog {
      overflow: hidden;
      transition: transform 0.3s ease-out, max-width 0.25s, height 0.25s !important;

      &.modal-full {
        margin-top: 0;
        max-width: 100vw;
        margin-bottom: 0;
        min-height: 100vh;

        .modal-content {
          min-height: 100%;
        }

        @include media-breakpoint-down(sm) {
          margin-left: 0;
          margin-right: 0;
        }
      }
    }

    &-body {

      & > .container {
        overflow-y: auto;
      }

      .close-icon {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }

  .separator {
    height: 1px;
    margin: 2rem -15px;
    position: relative;
    background-color: black;
    span {
      top: 50%;
      left: 50%;
      padding: 0 1rem;
      font-size: 0.75rem; /* 12/16 */
      position: absolute;
      white-space: nowrap;
      background-color: white;
      font-family: $gotham-font;
      transform: translate(-50%,-50%);
    }
  }

  .fa-check {
    line-height: 28px;
  }

  .border-bottom {
    border-color: $gray-500 !important;
  }

  .option {
    transition: background-color .25s;
    overflow: hidden;
  }

  .btn-min-width {
    min-width: 10.25rem;

    @include media-breakpoint-down(sm) {
      min-width: auto;
      flex: 1 1 auto !important;
    }
  }

  .opacity-90 {
    opacity: .9;
  }

}
</style>